import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

const ease = [0.16, 1, 0.3, 1];
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MovementClose() {
  const { t, locale } = useI18n();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    if (status === "loading") return;
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setStatus("error");
      setMessage(t.join.error);
      return;
    }
    setStatus("loading");
    setMessage("");
    try {
      const res = await axios.post(`${API}/subscribe`, { email: trimmed, locale });
      const data = res.data || {};
      setStatus("success");
      setMessage(data.already_subscribed ? t.join.successExisting : t.join.successNew);
      if (!data.already_subscribed) setEmail("");
    } catch (err) {
      setStatus("error");
      setMessage(t.join.error);
    }
  };

  return (
    <section
      id="join"
      className="section border-t hair"
      data-testid="movement-section"
    >
      <div className="container-edge">
        <SectionHead roman={t.sections.join.roman} />

        <div className="grid grid-cols-12 gap-y-12 md:gap-x-10 items-start">
          <motion.div
            className="col-span-12 md:col-span-6"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease }}
          >
            <h2 className="display text-[40px] sm:text-[52px] md:text-[72px] lg:text-[88px]" data-testid="movement-heading">
              {t.join.heading}
            </h2>
          </motion.div>

          <motion.div
            className="col-span-12 md:col-span-5 md:col-start-8"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease, delay: 0.1 }}
          >
            <form
              onSubmit={onSubmit}
              noValidate
              className="flex items-end gap-3"
              data-testid="email-signup-form"
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.join.placeholder}
                className="email-line flex-1"
                aria-label="email"
                autoComplete="email"
                data-testid="email-signup-input"
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="mono-md pb-3 transition-colors duration-300"
                style={{
                  color: status === "loading" ? "var(--faded)" : "var(--ink)",
                  background: "transparent",
                  border: "none",
                  cursor: status === "loading" ? "wait" : "pointer",
                }}
                data-testid="email-signup-submit"
                aria-label="submit"
              >
                {t.join.submit}
              </button>
            </form>
            {message && (
              <p
                className="mono mt-4"
                style={{
                  color: status === "error" ? "var(--hanko)" : "var(--faded)",
                }}
                data-testid="email-signup-message"
              >
                — {message}
              </p>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
